import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { FilterTabType } from '../../../imageFilters.model';
import { FilterHeader } from '../FilterHeader';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const InDatasetsHeader = observer((props: ImageFiltersFormProps): ReactElement => {
  const handleClear = (): void => {
    props.onSetInDatasets([]);
  };

  const isSelected = props.activeFilterType === FilterTabType.InDatasets;
  const count = props.imageFilters.datasets.length;

  return (
    <FilterHeader
      filterType={FilterTabType.InDatasets}
      isSelected={isSelected}
      labelKey={'datasets'}
      count={count}
      showClear={count > 0}
      onClear={handleClear}
      onSelect={props.onFilterTabSelect}
    />
  );
});
